import React, {Component} from 'react'
import ReactSwipe from 'react-swipe'
import { connect } from 'react-redux'
//import $ from 'jquery'

//import Registry from "../../../registry";

import VideoWindow from '../VideoWindow/index'

import {openStream} from '../../../actions/streaming';

import {
    //WINDOW_SIZES,
    VIDEO_WINDOW_CLOSE
} from '../../../constants/streaming';

class VideoWindowList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentSlide: 0,
            prevSlide: false,
            nextSlide: false,
            currentStreamId: null,
            previousStreamId: null,
            disableScroll: false,
            showSwipeHelp: true
        };

        //this.videoWindowSizes = WINDOW_SIZES.map(function(size) { return size+'-video'});

        this.haveSwipeFeature = props.browser.mobile && !props.browser.tablet;

    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        let htmlClasses = document.documentElement.classList;

        let {myVideoWindow, videoStreams} = this.props;

        let fullscreenVideo = false,
            openedVideos,
            videoWindowSize;

        for (let index in videoStreams) {
            fullscreenVideo = fullscreenVideo || videoStreams[index].fullscreen;
            openedVideos = true;
            videoWindowSize = videoStreams[index].size;
        }

        if (fullscreenVideo || myVideoWindow.fullscreen) {
            htmlClasses.add('fullscreen-video');

            if (htmlClasses.contains('window-video')) {
                htmlClasses.remove('window-video');
            }
        } else {
            if (htmlClasses.contains('fullscreen-video')) {
                htmlClasses.remove('fullscreen-video');
            }

            if (openedVideos) {
                htmlClasses.add('window-video') 
            } else {
                if (htmlClasses.contains('window-video')) {
                    htmlClasses.remove('window-video');
                }
            }
        }

        if(JSON.stringify(prevProps.visibleStreamIds) !== JSON.stringify(this.props.visibleStreamIds)) {
            this.removeStreamId();
        }

        //let slideIndex = $('.virtual-window').attr('data-index');
        //this.carousel && slideIndex != currentSlide && !disableScroll ? this.setState({currentSlide: +slideIndex}) : false;

    }

    // Used in the mobile version
    handleReactSwipe(index, elem) {
        let { dispatch } = this.props;

        this.setStreamId(index);
        this.setState({
            currentSlide: index,
            showSwipeHelp: false
        });

        let { currentStreamId, previousStreamId} = this.state;

        dispatch({type: VIDEO_WINDOW_CLOSE, stream_id: previousStreamId});
        dispatch(openStream(currentStreamId, this.props.ufrags[currentStreamId]));
        this.setState({previousStreamId: null});
    }

    removeStreamId() {
        this.setState({
            currentStreamId: null,
            previousStreamId: null
        });
    }

    setDisableScroll() {
        let { disableScroll } = this.state;

        this.setState({disableScroll: !disableScroll});
    }

    setStreamId(index = null) {
        let {
            currentStreamId,
            currentSlide,
            previousStreamId,
        } = this.state;
        let { availableStreamIds, videoStreams } = this.props;

        let newStreamId;
        let videoStreamsKeys = Object.keys(videoStreams);

        let newState = {};

        if(videoStreamsKeys.length > 0 && (index === null || index === currentSlide)) {
            newStreamId = videoStreams[videoStreamsKeys[0]].stream_id;
        } else {
            let switchStreamId = index > currentSlide ? 1 : -1;

            newStreamId = availableStreamIds[availableStreamIds.indexOf(currentStreamId) + switchStreamId];
            if(previousStreamId) {
                newState = {...newState,
                    previousStreamId: null
                };
            }
        }

        if(this.state.currentStreamId !== newStreamId && this.state.previousStreamId !== newStreamId) {
            newState = ({ ...newState,
                currentStreamId: newStreamId,
                previousStreamId: currentStreamId
            });
        }

        this.setState(newState);
    }

    static getDerivedStateFromProps(props, state) {

        if(props.browser.mobile && !props.browser.tablet && props.videoStreams) {

            let videoStreamsKeys = Object.keys(props.videoStreams);

            if(videoStreamsKeys.length > 0) {
                let currentStreamId,
                    newState = {};

                if (!state.currentStreamId) {
                    //There is actually a single video in array, so we take ufrag from that video
                    currentStreamId = props.videoStreams[videoStreamsKeys[0]].stream_id;
                    newState = {
                        ...newState,
                        currentStreamId: currentStreamId
                    };
                } else {
                    currentStreamId = state.currentStreamId;
                }

                let prevSlide = !!props.availableStreamIds[props.availableStreamIds.indexOf(currentStreamId) - 1];
                let nextSlide = !!props.availableStreamIds[props.availableStreamIds.indexOf(currentStreamId) + 1];

                newState = {
                    ...newState,
                    prevSlide: prevSlide,
                    nextSlide: nextSlide,
                    currentSlide: prevSlide ? 1 : 0
                };

                return newState;
            }
        }

        return null;
    }

    render() {
        let { disableScroll, prevSlide, nextSlide, currentSlide } = this.state;
        let { videoStreams, currentUser, browser, watcherCount, isFullscreenVideo } = this.props;

        let windows = [];

        for (let streamId in videoStreams) {
            let videoStream = videoStreams[streamId];
            let fullscreenStream = (this.props.fullscreen.stream_id == streamId);
            let popStream = !fullscreenStream && (this.props.fullscreen.uid == videoStream.user.uid);
            let windowBehaviour = fullscreenStream ? "fullscreen" : (popStream ? "pic-in-pic" : "floating");
            windows.push(
                <VideoWindow 
                    key={streamId}
                    streamId={streamId}
                    behaviour={windowBehaviour}
                    fullscreenStream={fullscreenStream}
                    fullscreenSettings={this.props.fullscreen}
                    popStream={popStream}
                    videoStream={videoStream} 
                    watcherCount={watcherCount[streamId] || 0} 
                    currentUser={currentUser} 
                    browser={browser} 
                    dispatch={this.props.dispatch}
                    setDisableScroll={() => this.setDisableScroll()}
                />
            );
        }

        return (
            <div className="other-stream">
                {windows.length && this.haveSwipeFeature && !isFullscreenVideo ?
                    <div>
                        <ReactSwipe
                            className="carousel"
                            swipeOptions={{
                                continuous: false,
                                stopPropagation: true,
                                startSlide: currentSlide,
                                disableScroll: disableScroll,
                                callback: (index, elem) => this.handleReactSwipe(index, elem)
                            }}
                            ref={el => this.carousel = el}
                        >
                            {prevSlide ? <div className="popup-video window prev-slide connecting left" /> : null}
                            {windows}
                            {nextSlide ? <div className="popup-video window next-slide connecting right" /> : null}
                        </ReactSwipe>
                        {this.state.showSwipeHelp ? <div className="swipe-help"></div> : null}
                    </div>
                : windows}
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {

    let {videoStreams, currentUser} = state;

    let items = [];
    let currentRoom = state.visibleChatrooms.roomid ? state.rooms[state.visibleChatrooms.roomid] : undefined;
    if (currentRoom) {
        items = currentRoom.users.items;
    }

    let newUfrags = {};
    let newStreamIds = [];

    for (let i in items) {
        let user = items[i];
        if (user.streaming) for (let si in user.streams) {
            if (si == "undefined") { continue; }
            newStreamIds.push(si);
            newUfrags[si] = user.ufrag;
        }
    }


   // items.forEach(user => user.streaming && user.ufrag !== currentUser.ufrag ? newUfrags.push(user.ufrag) : false, this);

    let isFullscreenVideo = state.fullscreen.fullscreen;
    let visibleStreamIds = [];

    for (let streamId in videoStreams) {
        visibleStreamIds.push(streamId);
    }

    let watcherCount = {};

    for (let roomid in state.rooms) {
        let wc = state.rooms[roomid].watcherCount;
        watcherCount = {
            ...watcherCount,
            ...wc
        }
    }

    return {
        ufrags: newUfrags,
        availableStreamIds: newStreamIds,
        videoStreams: state.videoStreams,
        visibleStreamIds: visibleStreamIds,
        userSorting: state.userSorting,
        watcherCount: watcherCount,
        myVideoWindow: state.myVideoWindow,
        currentUser: state.currentUser,
        browser: state.browser,
        isFullscreenVideo: isFullscreenVideo,
        fullscreen: state.fullscreen
    };

}

export default connect(mapStateToProps)(VideoWindowList);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/VideoWindowList/index.js